@let balance = balanceInfoWithLoadingStatus$ | async;

<div class="user-info" dataAttribute componentName="header-user-info">
  <b2b-logo
    *showOnPlatformNarrow="Platform.Mobile"
    class="user-info__logo"
    type="compact"
    dataAttribute
    componentName="mobile-logo"
  />

  <div class="user-info__content">
    <div class="user-info--left">
      <b2b-profile-info class="user-info__profile-info" type="header" />

      <tiss-selection-helper
        *showOnPlatformNarrow="Platform.Desktop"
        class="user-info__selection-helper"
      ></tiss-selection-helper>
    </div>
    <div class="user-info--right">
      <b2b-user-balance-info
        class="user-info__balance"
        [balanceInfoWithLoadingStatus]="balance"
        (makePaymentForBalance)="makePaymentForBalanceClick()"
        (updateBalance)="updateBalanceInfoClick()"
      />

      <div class="user-info-language-bell-wrapper">
        <b2b-language-selector *showOnPlatformNarrow="Platform.Desktop" />
      </div>
    </div>

    <b2b-portal-notification-bell
      *showOnPlatformNarrow="Platform.Tablet"
      dataAttribute
      componentName="header-user-info-notification-bell"
    />
  </div>
</div>
